import { render } from "./view-details.vue?vue&type=template&id=2dd8b88d"
import script from "./view-details.vue?vue&type=script&lang=js"
export * from "./view-details.vue?vue&type=script&lang=js"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__